export const DATE_DIFFERENCE_VALUES = process.env.REACT_APP_API_ENV !== 'x' ? [
  { label: 'Past 180 days', value: 179 },
  { label: 'Past 90 days', value: 89 },
  { label: 'Past 30 days', value: 29 },
  { label: 'Past 7 days', value: 6 },
] : [
  { label: 'Past 30 days', value: 29 },
  { label: 'Past 7 days', value: 6 }
];
